const doc = [({"daily":"日次", "monthly":"月次", "custom":"期間選択"})];
module.exports = doc.length <= 1 ? doc[0] : doc;